.multi-select-cell {
  display: flex;
  color: transparent; // hides the checkbox placeholder label
  margin-left: 2px; // offset the checkbox to compensate for the placeholder label
}

.single-select-header-cell {
  display: flex;
  justify-content: center;
}

.single-select-cell {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  margin: 0;
}

.radio-button {
  margin-left: calc(var(--spacer) * 0.5);
}
